// check if a document has valid OCR/Text content
import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
import pluralize from 'pluralize';

import { EN_DASH } from '~/common/constants/unicode';

type GhostCandidate = { document_handlers?: unknown[] };

export function hasOcrContent(doc: { file_type?: string }) {
  return doc.file_type === '.pdf';
}

export function getLabelForDocumentCount(
  fileCount?: number,
  docCount?: number,
) {
  let label = EN_DASH;

  if (fileCount && docCount && docCount >= fileCount) {
    let duplicates = docCount - fileCount;

    label = `${fileCount} ${pluralize('document', fileCount)}`;
    if (duplicates > 0) {
      label += ` (${duplicates} ${pluralize('duplicate', duplicates)})`;
    }
  }

  return label;
}

export const testIsAnyDocumentNotMovable = (
  documents: Array<{ is_movable?: boolean }> = [],
) => {
  return documents.some((doc) => !doc.is_movable);
};

export const testIsGhostSearchResultDocument = (doc: GhostCandidate = {}) => {
  return !doc.document_handlers?.length;
};

export const testContainsGhostSearchResult = (
  documents: GhostCandidate[] = [],
) => {
  return documents.some(testIsGhostSearchResultDocument);
};

export const getUniqueFieldValues = <T>(values: T[] | null = []) => {
  return values && values.length > 0 ? uniqWith(values, isEqual) : [];
};
